export default __webpack_public_path__ + "static/media/banner.100eda64.png";